
import { routes } from '../config/api_routes'

export const customerVehicleService = {

    //get Customer Vehicle
    // info: sortDesc : Boolean
    
    getCustomerVehicle: (formData) => window.axios.post(routes.getCustomerVehicleApi,formData),

    //delete Customer Vehicle
    deleteCustomerVehicleById: (formData) => window.axios.post(routes.deleteCustomerVehicleApi,formData),

    //get by id Customer Vehicle
    getCustomerVehicleById: (formData) => window.axios.post(routes.getCustomerVehicleApiById, formData),
    
    //Get Edit Model Data 
    editModelData: (formData) => window.axios.post(routes.editModelDataApi, formData),
    
    //Get Edit Model Data 
    editModelColorData: (formData) => window.axios.post(routes.editModelColorDataApi, formData),
    
}